export default "__VITE_ASSET__C59LDObg__"